export default "assets/shadowfax-logo.png"